import { render } from "./tests.vue?vue&type=template&id=4e517cd3&scoped=true"
import script from "./tests.vue?vue&type=script&lang=js"
export * from "./tests.vue?vue&type=script&lang=js"

import "./tests.vue?vue&type=style&index=0&id=4e517cd3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e517cd3"]])

export default __exports__